module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-ui/static-1.2723/img/video-thumb-overlay.png"


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/ecosystem-marketplace-apps/node_modules/bender-webpack/lib/bender-url-loader.js!./img/video-thumb-overlay.png
// module id = 803
// module chunks = 209 210 211 212